import ApplicationController from "../turbo/application_controller";
import { createPopup } from "../turbo/lib/popup";

export default class extends ApplicationController {
    static targets = ["toggle", "menu"];

    static values = { bottomEnd: Boolean, overflow: String }

    toggleTargetConnected(element) {
        this.overflow = this.overflowValue;

        this.popup = createPopup(element, this.menuTarget, {
            placement: this.placement,
            modifiers: [{
                name: "offset",
                options: { offset: [0, 8] },
            }]
        });
    }

    get placement() {
        return this.bottomEndValue ? "bottom-end" : "bottom-start";
    }

    get isOpen() {
        return String(this.menuTarget.dataset.open) === "true";
    }

    set overflow(value) {
        this.menuTarget.style.overflow = value;
    }

    set isOpen(value) {
        this.menuTarget.dataset.open = value;
    }

    open() {
        this.isOpen = "true";
        this.popup.update();
    }

    close(e) {
        if (e && e.target.closest(e.params.ignoreSelector)) { return; }
        if (e && this.toggleTarget.contains(e.target)) { return; }

        this.isOpen = false;
    }

    toggle() {
        this.isOpen ? this.close() : this.open();
    }
}
